import { Alert, Grid } from '@mui/material';

interface InfoBoxProps {
  visible?: boolean;
  children?: React.ReactNode;
}

export const InfoBox = ({ visible = true, children }: InfoBoxProps) => {
  return visible ? (
    <Grid container justifyContent="center">
      <Alert severity="info">{children}</Alert>
    </Grid>
  ) : null;
};
